<template>
  <div class="comp-end-line">
    <div class="end-line"><span style="padding-left: 10px;padding-right: 10px;">{{text}}</span></div>
  </div>
</template>

<script>
  export default {
    name: 'comp-end-line',
    props: {
      text: {
        type: String,
        default: '已经到底部啦'
      }
    }
  }
</script>

<style lang="less">
  .comp-end-line {
    .end-line {
      text-align: center;
      display: flex;
      justify-content: space-between;
      align-content: center;
      margin: 0 auto;
      white-space: nowrap;
      color:#bbb;
      font-size:12px;
      &:after,&:before{
        content: '';
        display: block;
        width:33%;
        margin-top:-2px;
        border-bottom:2px solid #dddddd;
        transform: rotateX(80deg);
      }
    }
  }
</style>
